import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HeaderLeft from "../HeaderLeft";
import HeaderRight from "../HeaderRight";
// logo
import GroupLogo from "Assets/images/Group.png";
import GroupLogoWhite from "Assets/images/GroupWhite.png";
import { GetQuery } from "Pub/js/utils";

class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state={
            testText: ''
        }
    }

    render() {
        const {
            themeColor, // 主题
            // 这些是子组件依赖的可以下放至子组件内部
            is_cloud_register,
            deployType,
            groupId,
            allowPaint,
            userType,
            // ---------上面的是redux存的，下面的是父组件传进来的---------
            fieldid,
            ispreview = false, // 是否预览态
            navConfig = {}, // 配置项
            onNavHandle = () => {},
        } = this.props;
        const commonProps = {
            ispreview,
            navConfig
        }
        const { ifr = '' } = GetQuery(this.props.location.search);
        const isGlobalSearchCenter = ifr.indexOf("searchCenterPage") !== -1;
        const { theme = {}, isHome } = navConfig;
        return <nav fieldid={`${fieldid}_top-area`} className={`nc-workbench-nav`}>
            <div className={['nav-left', 'n-left', 'n-v-middle'].join(' ')}>
                <HeaderLeft
                    onAllAppClick={() => { onNavHandle({ type: 'app-click' }) }}
                    onBreadCrumbClick={(...args) => { onNavHandle({ type: 'breadcrumb-click', data: args }) }}
                    {...commonProps}
                />
            </div>
            {
                (isHome || ispreview || isGlobalSearchCenter)
                ? <div 
                    className='nav-middle' 
                    // onClick={()=>{
                    //     //切换缓存
                    //     let newVisual = JSON.parse(localStorage.getItem('new-visual'));       
                    //     if(newVisual === null){
                    //         this.setState({
                    //             testText: '使用新视觉'
                    //         }) 
                    //         localStorage.setItem('new-visual', JSON.stringify(true));
                    //     }else{
                    //         if(newVisual){
                    //             this.setState({
                    //                 testText: ''
                    //             })
                    //         }else{
                    //             this.setState({
                    //                 testText: '使用新视觉'
                    //             }) 
                    //         }
                    //         localStorage.setItem('new-visual', JSON.stringify(!newVisual));
                    //     }
                        
                    // }}
                    >
                        <img
                            className='logo'
                            src={navConfig.logo || (['default', 'default1', 'black', 'mixin'].includes(ispreview ? theme.type : themeColor) ? GroupLogo : GroupLogoWhite)}
                        />
                        {/* <div>
                        {this.state.testText && <span>
                            <span style={{
                                fontSize: '14px',
                                color:'blue',
                            }}>
                               {this.state.testText}
                            </span>
                            <span>(临时演示用不要提bug)</span>
                            
                            </span>
                        }  
                        </div> */}
                    </div>
                : null
            }
            <div className='nav-right n-right n-v-middle'>
                {
                    // 这个组件里有im和小友，都是依赖STOREFORSYSTEM里的开关的
                    // 必须等拿到数据再渲染，用allowPaint这个可以来判断，这个表示业务数据已经设置完毕，借用一下
                    allowPaint && <HeaderRight
                        userType={userType}
                        is_cloud_register={is_cloud_register}
                        deployType={deployType}
                        groupId={groupId}
                        getMessage={(...args) => { onNavHandle({ type: 'get-message', data: args }) }}
                        hideSearch={isGlobalSearchCenter}
                        {...commonProps}
                    />
                }
            </div>
        </nav>
    }
}

export default withRouter(connect(
    state => ({
        themeColor: state.appData.themeColor,
        groupId: state.appData.groupId,
        is_cloud_register: state.appData.is_cloud_register,
        deployType: state.appData.deployType,
        allowPaint: state.ifrData.allowPaint,
        userType: state.appData.userType,
    }),
    {},
)(NavBar));